import React, { useContext, useState } from "react";
import Tabination from "./Tabination";
import { filterDataContext } from "../../App";
import MobileBottomSheet from "./BottomSheet";

const MobileFilter = ({ searchParams, setSearchParams }) => {
  const { bottomSheetview, setBottomSheetView } = useContext(filterDataContext);
  return (
    <>
      <Tabination />
      {bottomSheetview === true && (
        <MobileBottomSheet
          setBottomSheetView={setBottomSheetView}
          bottomSheetview={bottomSheetview}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      )}
    </>
  );
};

export default MobileFilter;
